// images
import blogImg1 from "../images/blog/blog-1/1.jpg";
import blogImg2 from "../images/blog/blog-1/2.jpg";
import blogImg3 from "../images/blog/blog-1/3.jpg";

import blogSingleImg1 from "../images/blog-details/1.jpg";
import blogSingleImg2 from "../images/blog-details/2.jpg";
import blogSingleImg3 from "../images/blog-details/3.jpg";

const blogs = [
    {
        id: '1',
        title: 'The Future of Architectural Design in India',
        title2: 'The Future of Architectural Design in India',
        subtitle: 'ARCHITECTURE / BY: YV Reddy Associates',
        slug: 'future-of-architectural-design-in-india',
        screens: blogImg1,
        link: 'READ MORE',
        description: 'Explore how modern architectural design in India is evolving with smart planning, sustainability, and functional excellence.',
        author: 'YV Reddy Associates',
        create_at: '15 Jan 2026',
        blogSingleImg: blogSingleImg1,
        comment: '0',
        day: '15',
        month: 'JAN',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '2',
        title: 'Why Professional Office Interior Design Matters',
        title2: 'Why Professional Office Interior Design Matters',
        subtitle: 'INTERIORS / BY: YV Reddy Associates',
        slug: 'professional-office-interior-design',
        screens: blogImg2,
        link: 'READ MORE',
        description: 'Learn how expert office interior design enhances productivity, brand identity, and efficient workspace planning.',
        author: 'YV Reddy Associates',
        create_at: '15 Jan 2026',
        blogSingleImg: blogSingleImg2,
        comment: '0',
        day: '15',
        month: 'JAN',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '3',
        title: 'Turnkey Contracting: From Concept to Completion',
        title2: 'Turnkey Contracting: From Concept to Completion',
        subtitle: 'TURNKEY / BY: YV Reddy Associates',
        slug: 'turnkey-contracting-services',
        screens: blogImg3,
        link: 'READ MORE',
        description: 'Understand how turnkey contracting ensures seamless execution, cost control, and stress-free project delivery.',
        author: 'YV Reddy Associates',
        create_at: '15 Jan 2026',
        blogSingleImg: blogSingleImg3,
        comment: '0',
        day: '15',
        month: 'JAN',
        blClass: 'format-standard-image',
        animation: '1200',
    },
];

export default blogs;
